/* src/app/shared/category/category-list/category-list.component.scss */
/*# sourceMappingURL=category-list.component.css.map */
